import {
	addressConstants
} from './address.constants';
import {
	addressService
} from 'services';

export const addressActions = {
	sendAddress
};

function sendAddress(payload) {
	return (dispatch) => {
		dispatch(request());
		return addressService.sendAddress(payload)
			.then(
				result => {
					dispatch(success(result))
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error))
					return Promise.reject(error);
				}
			);
	};

	function request() {
		return {
			type: addressConstants.SEND_ADDRESS_REQUEST,
		};
	}

	function success() {
		return {
			type: addressConstants.SEND_ADDRESS_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: addressConstants.SEND_ADDRESS_ERROR,
			error,
		};
	}
}